import React from "react";
import styles from "./NotToday.module.css";

const NotToday: React.FC = () => {
  const blockBrowserBack = React.useCallback(() => {
    window.history.go(1);
  }, []);

  React.useEffect(() => {
    // 直前の履歴に現在のページを追加
    window.history.pushState(null, "", window.location.href);

    // 直前の履歴と現在のページのループ
    window.addEventListener("popstate", blockBrowserBack);

    // クリーンアップ
    return () => {
      window.removeEventListener("popstate", blockBrowserBack);
    };
  }, [blockBrowserBack]);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}> またのお越しをお待ちしています</h1>
    </div>
  );
};

export default NotToday;
